import * as z from 'zod';

export const marketingCampaignTableSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
});

export type MarketingCampaignTableSchema = z.infer<typeof marketingCampaignTableSchema>;
